<template>
  <div class="product">
    <div class="product-container-inner">
      <!-- <node-element-local-tasks :itemid="singleProduct.id" :options="{ mode: 'view' }"/> -->

      <h3>
        <span
          v-if="!customClub"
          class="amount"
        >{{ singleProduct.amount }}x</span>
        {{ singleProduct.title }}
      </h3>

      <div
        v-if="singleProduct.award_winner"
        class="award-winner"
      >
        Award Winner
      </div>

      <template v-if="!showAbstract">
        <transition name="slide-fade">
          <template v-if="singleProduct.images[0]">
            <div
              class="cursor-q"
              @click="showAbstract = true"
            >
              <AImage
                :img="singleProduct.images[0].image"
                preset="__original"
                contain
              />
            </div>
          </template>
        </transition>
      </template>
      <template v-else>
        <transition name="slide-fade">
          <div
            class="abstract cursor-q"
            @click="showAbstract = false"
            v-html="singleProduct.abstract"
          />
        </transition>
      </template>

      <div
        v-if="customClub && singleProduct.productsettings.price"
        class="money-amount"
      >
        <span class="currency">{{ this.$store.getters['ecommerce/getConfigItem']('currency') }}$</span> {{ parseFloat(singleProduct.productsettings.price).toFixed(2) }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'product',
  props: {
    product: {
      type: Object,
      required: true
    },
    customClub: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      showAbstract: false
    }
  },
  computed: {
    singleProduct() {
      return this.product
    }
  }
}
</script>

<style scoped lang="scss">
.product {
  position: relative;
  padding: 1em;
  flex: 1;
  margin: 1em;
  min-width: 15em;
  border: 1px solid var(--main-border-color);
  .award-winner {
    position: absolute;
    right: -0.6em;
    top: -0.6em;
    background: var(--main-award-badge-background-color);
    color: var(--main-award-badge-text-color);
    text-align: center;
    border-radius: 50%;
    width: 5em;
    height: 5em;
    font-size: 0.9em;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .product-container-inner {
    max-width: 15em;
    margin: auto;
    h3 {
      margin: 1.5em 0 0 0;
    }
    .money-amount {
      color: var(--main-text-highlight-color);
      font-weight: bold;
      text-align: center;
    }
    .abstract {
      margin-top: 1em;
    }
  }
  .cursor-q {
    cursor: help;
  }
 ::v-deep .page-options {
    bottom: 1em;
    top: auto;
    right: 1em;
  }
}
</style>
